import config from 'next/config';
const { publicRuntimeConfig } = config();

export const consultMenus = [
  {
    title: 'مشاوره پزشکی با بهترین متخصص آنلاین',
    link: `/consult`,
  },
  {
    title: 'دکتر آنلاین روانشناسی',
    link: `/s/ir/psychology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین ارتوپدی',
    link: `/s/ir/orthopedics/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین ارتوپدی اطفال',
    link: `/s/ir/exp-pediatric-orthopedics/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین ازدواج',
    link: `/s/ir/q-ازدواج/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین استرس',
    link: `/s/ir/q-مشاور-استرس/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین اطفال',
    link: `/s/ir/pediatrics/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین اعتیاد',
    link: `/s/ir/q-روانپزشک-ترک-اعتیاد/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین اورولوژی',
    link: `/s/ir/urology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین آلرژی',
    link: `/s/ir/allergies/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین بارداری',
    link: `/s/ir/q-دکتر-بارداری/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین بیهوشی',
    link: `/s/ir/anesthesia-and-intensive-care/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین پارکینسون',
    link: `/s/ir/q-دکتر-پارکینسون/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین پریود',
    link: `/s/ir/q-پریود/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین پوست و مو',
    link: `/s/ir/dermatology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین توانبخشی',
    link: `/s/ir/rehabilitation/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین تیرویید',
    link: `/s/ir/q-دکتر-تیروئید/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین جراحی',
    link: `/s/ir/surgery/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین جراحی زیبایی صورت',
    link: `/s/ir/exp-plastic-reconstructive-and-burn-surgery/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین چشم پزشکی',
    link: `/s/ir/ophthalmology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین خون و سرطان',
    link: `/s/ir/oncology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین داخلی',
    link: `/s/ir/internal/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین داروسازی',
    link: `/s/ir/pharmacology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین دندانپزشکی',
    link: `/s/ir/dental-oral/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین دیابت',
    link: `/s/ir/diabetes/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین تغذیه',
    link: `/s/ir/nutrition/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین روانپزشکی',
    link: `/s/ir/psychiatry/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین ریه',
    link: `/s/ir/pulmonology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین زنان',
    link: `/s/ir/obstetrics-gynecology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین ژنتیک',
    link: `/s/ir/genetics/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین سرطان روده',
    link: `/s/ir/q-سرطان-روده/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین سلامت جنسی',
    link: `/s/ir/sexual-health/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین طب اورژانس',
    link: `/s/ir/exp-emergency-medicine/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین طب سنتی',
    link: `/s/ir/traditional-medicine/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین عفونت ادراری',
    link: `/s/ir/q-دکتر-عفونت-ادراری/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین عفونت زنان',
    link: `/s/ir/q-دکتر-عفونت-واژن/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین عفونی',
    link: `/s/ir/infectious/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین عمومی',
    link: `/s/ir/general-practitioner/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین غدد اطفال',
    link: `/s/ir/exp-pediatric-endocrinology-and-metabolism/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین غدد و دیابت',
    link: `/s/ir/endocrinology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین قلب و عروق',
    link: `/s/ir/cardiovascular/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین کرونا',
    link: `/s/ir/corona-virus/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین کیست تخمدان',
    link: `/s/ir/q-کیست-تخمدان/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین گفتار درمانی',
    link: `/s/ir/exp-speech-therapy-1/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین گوش، حلق و بینی',
    link: `/s/ir/otorhinolaryngology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین مامایی',
    link: `/s/ir/exp-midwifery/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین مشاوره خانواده',
    link: `/s/ir/q-مشاوره-خانواده/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین معده و گوارش',
    link: `/s/ir/gastroenterology/?turn_type=consult`,
  },
  {
    title: 'دکتر آنلاین مغز و اعصاب',
    link: `/s/ir/neurology/?turn_type=consult`,
  },
];

export const articleMenus = [
  {
    title: 'لیست اطلاعات دارویی',
    link: `/blog/category/drugs/`,
  },
  {
    title: 'مقالات استخوان و مفاصل',
    link: `/blog/category/hc-content/%d8%a7%d8%b3%d8%aa%d8%ae%d9%88%d8%a7%d9%86-%d9%88-%d8%a7%d8%b1%d8%aa%d9%88%d9%be%d8%af/`,
  },
  {
    title: 'مقالات اطفال، کودکان و نوزادان',
    link: `/blog/category/hc-content/hc-children/`,
  },
  {
    title: 'مقالات آزمایشگاه و تصویربرداری',
    link: `/blog/category/hc-content/%d9%85%d9%82%d8%a7%d9%84%d8%a7%d8%aa-%d8%a2%d8%b2%d9%85%d8%a7%db%8c%d8%b4%da%af%d8%a7%d9%87-%d9%88-%d8%aa%d8%b5%d9%88%db%8c%d8%b1%d8%a8%d8%b1%d8%af%d8%a7%d8%b1%db%8c/`,
  },
  {
    title: 'مقالات آلرژی',
    link: `/blog/category/hc-content/%d9%85%d9%82%d8%a7%d9%84%d8%a7%d8%aa-%d8%a2%d9%84%d8%b1%da%98%db%8c/`,
  },
  {
    title: 'مقالات بیهوشی و مراقبت های ویژه',
    link: `/blog/category/%D9%85%D9%82%D8%A7%D9%84%D8%A7%D8%AA-%D8%A8%DB%8C%D9%87%D9%88%D8%B4%DB%8C-%D9%88-%D9%85%D8%B1%D8%A7%D9%82%D8%A8%D8%AA-%D9%87%D8%A7%DB%8C-%D9%88%DB%8C%DA%98%D9%87/`,
  },
  {
    title: 'مقالات پوست و مو',
    link: `/blog/category/hc-content/dermatology/`,
  },
  {
    title: 'مقالات تغذیه',
    link: `/blog/category/hc-content/%d9%85%d9%82%d8%a7%d9%84%d8%a7%d8%aa-%d8%aa%d8%ba%d8%b0%db%8c%d9%87/`,
  },
  {
    title: 'مقالات توانبخشی و فیزیوتراپی',
    link: `/blog/category/hc-content/%d9%85%d9%82%d8%a7%d9%84%d8%a7%d8%aa-%d8%aa%d9%88%d8%a7%d9%86%d8%a8%d8%ae%d8%b4%db%8c-%d9%88-%d9%81%db%8c%d8%b2%db%8c%d9%88%d8%aa%d8%b1%d8%a7%d9%be%db%8c/`,
  },
  {
    title: 'مقالات جراحی',
    link: `/blog/category/hc-content/hc-surgery/`,
  },
  {
    title: 'مقالات چشم پزشکی',
    link: `/blog/category/hc-content/hc-eye/`,
  },
  {
    title: 'مقالات خون، سرطان و آنکولوژی',
    link: `/blog/category/hc-content/hc-blood-and-cancer/`,
  },
  {
    title: 'مقالات داخلی',
    link: `/blog/category/hc-content/hc-internal/`,
  },
  {
    title: 'مقالات دهان و دندان',
    link: `/blog/category/hc-content/hc-mouthandtooth/`,
  },
  {
    title: 'مقالات دیابت',
    link: `/blog/category/hc-content/%d9%85%d9%82%d8%a7%d9%84%d8%a7%d8%aa-%d8%af%db%8c%d8%a7%d8%a8%d8%aa/`,
  },
  {
    title: 'مقالات روانپزشکی',
    link: `/blog/category/hc-content/%d9%85%d9%82%d8%a7%d9%84%d8%a7%d8%aa-%d8%b1%d9%88%d8%a7%d9%86%d9%be%d8%b2%d8%b4%da%a9%db%8c/`,
  },
  {
    title: 'مقالات روانشناسی',
    link: `/blog/category/hc-content/hc-psychology-psychiatry/`,
  },
  {
    title: 'مقالات ریه و دستگاه تنفسی',
    link: `/blog/category/hc-content/hc-pulmonology/`,
  },
  {
    title: 'مقالات زنان، زایمان و نازایی',
    link: `/blog/category/hc-content/obstetrics-and-gynecology/`,
  },
  {
    title: 'مقالات زیبایی',
    link: `/blog/category/hc-content/%d9%85%d9%82%d8%a7%d9%84%d8%a7%d8%aa-%d8%b2%db%8c%d8%a8%d8%a7%db%8c%db%8c/`,
  },
  {
    title: 'مقالات ژنتیک',
    link: `/blog/category/%D9%85%D9%82%D8%A7%D9%84%D8%A7%D8%AA-%DA%98%D9%86%D8%AA%DB%8C%DA%A9/`,
  },
  {
    title: 'مقالات سلامت جنسی',
    link: `/blog/category/hc-content/hc-sexual-health/`,
  },
  {
    title: 'مقالات طب تسکینی و درد',
    link: `/blog/category/%D9%85%D9%82%D8%A7%D9%84%D8%A7%D8%AA-%D8%B7%D8%A8-%D8%AA%D8%B3%DA%A9%DB%8C%D9%86%DB%8C-%D9%88-%D8%AF%D8%B1%D8%AF/`,
  },
  {
    title: 'مقالات طب سنتی',
    link: `/blog/category/hc-content/%d8%b7%d8%a8-%d8%b3%d9%86%d8%aa%db%8c/`,
  },
  {
    title: 'مقالات عفونی',
    link: `/blog/category/hc-content/hc-infectious-and-viral/`,
  },
  {
    title: 'مقالات عمومی',
    link: `/blog/category/public/`,
  },
  {
    title: 'مقالات غدد و متابولیسم',
    link: `/blog/category/hc-content/%d9%85%d9%82%d8%a7%d9%84%d8%a7%d8%aa-%d8%ba%d8%af%d8%af-%d9%88-%d9%85%d8%aa%d8%a7%d8%a8%d9%88%d9%84%db%8c%d8%b3%d9%85/`,
  },
  {
    title: 'مقالات قلب و عروق',
    link: `/blog/category/hc-content/hc-cardiovascular/`,
  },
  {
    title: 'مقالات کرونا ویروس',
    link: `/blog/category/hc-content/corona-virus-covid19/`,
  },
  {
    title: 'مقالات کلیه و مجاری ادراری',
    link: `/blog/category/hc-content/hc-kidneys-and-urinary-tract/`,
  },
  {
    title: 'مقالات گوارش و معده',
    link: `/blog/category/hc-content/hc-stomach-digestion/`,
  },
  {
    title: 'مقالات گوش، حلق و بینی',
    link: `/blog/category/hc-content/hc-ears-throat-and-nose/`,
  },
  {
    title: 'مقالات مغز و اعصاب',
    link: `/blog/category/hc-content/%d9%85%d8%ba%d8%b2-%d9%88-%d8%a7%d8%b9%d8%b5%d8%a7%d8%a8/`,
  },
];

export const withUserMenu = [
  {
    title: 'جستجو پزشکان و دریافت نوبت ',
    link: '/s/',
  },
  {
    title: 'نوبت های من ',
    link: '/patient/appointments',
  },
  {
    title: 'اپلیکیشن پذیرش 24',
    link: '/app/',
  },
  {
    title: 'راهنمای دریافت نوبت ',
    link: '/home/help/',
  },
  {
    title: 'سوالات متداول',
    link: '/faq/',
  },
  {
    title: 'مجله سلامتی',
    link: '/blog/',
  },
];

export const withDoctorMenu = [
  {
    title: 'ورود / ثبت نام پزشکان ',
    link: `https://providers.paziresh24.com/?header`,
  },
];

export const medicalCenterMenu = [
  {
    title: 'ثبت نام مراکز درمانی',
    link: `https://survey.porsline.ir/s/YCEGAgx`,
  },
  {
    title: 'تعرفه مراکز درمانی',
    link: `/_/pricing/calculator/`,
  },
];

export const developersMenu = [
  {
    title: 'فرصت‌های شغلی',
    link: 'https://join.paziresh24.com',
  },
  {
    title: 'مستندات API',
    link: 'https://hamdast.paziresh24.com',
  },
];
